/* Common method to add cardPosition property */
export const addCardPositionProperty = (vehiclesObject: any, position: number) =>
  vehiclesObject.map((vehicle: any) => {
    position += 1;
    return {
      ...vehicle,
      ...{
        cardPosition: position,
      },
    };
  });

/* Handler to add card position property for left rail cards in the order they are rendered */
export const addCardPosition = (data: any) => {
  const state = {
    ...data,
  };
  let position = 0; // initial card position value

  // Add rendered card position property for pre purchase vehicles
  if (state?.prePurchaseVehicles) {
    const { prePurchaseVehicles } = state;

    state.prePurchaseVehicles = addCardPositionProperty(prePurchaseVehicles, position);
    position += prePurchaseVehicles.length;
  }

  // Add rendered card position property for pre order vehicles
  if (state?.preOrderVehicles) {
    const { preOrderVehicles } = state;

    state.preOrderVehicles = addCardPositionProperty(preOrderVehicles, position);
    position += preOrderVehicles.length;
  }

  // Add rendered card position property for post purchase vehicles
  if (state?.postPurchaseVehicles) {
    const { postPurchaseVehicles } = state;
    state.postPurchaseVehicles = addCardPositionProperty(postPurchaseVehicles, position);
    position += postPurchaseVehicles.length;
  }

  if (state?.appraisals) {
    const { appraisals } = state;
    state.appraisals = addCardPositionProperty(appraisals, position);
  }

  return state;
};

/* Filter essential user data for event */
export const filterUserData: any = (purchasesData: any) =>
  purchasesData?.map((vehicleData: any) => ({
    purchaseState: vehicleData.purchaseState,
    vehicleId: vehicleData.vehicle.id,
    vin: vehicleData.vehicle.vin,
    dueDate: vehicleData.loanSummary?.dueDate,
    nextPaymentDate: vehicleData.loanSummary?.nextPaymentDate,
    nextPaymentType: vehicleData.loanSummary?.nextPaymentType,
    loanPaymentStatus: vehicleData.loanSummary?.loanPaymentStatus,
  }));

// Capitalize first word in sentences with periods.

export const capitalizeParagraph = (text: string) => {
  const lowerCaseText = text?.toLowerCase();
  if (!lowerCaseText) return '';
  const textToCapitalize = lowerCaseText?.charAt?.(0)?.toUpperCase() + lowerCaseText?.slice?.(1);
  return textToCapitalize
    ? textToCapitalize?.replace(/([!?.]\s+)([a-z])/g, (m: any, $1: string, $2: string) => {
        return $1 + $2?.toUpperCase();
      })
    : '';
};
